const $ = require('./src/jquery');
module.exports = $;
